/* eslint-disable react-refresh/only-export-components */
import type { TFunction } from "i18next";

// Подтекст „(към Бургер от Топла Кухня)" за добавка, чийто основен продукт е
// на ДРУГА станция (не е видим на този монитор). BE праща mainProductName/
// mainStationName само на такива редове; при видим родител (монитор с двете
// станции) MonitorsContent ги чисти и подтекст няма. Форматът е 1:1 с
// кухненския бон (parent_ref).
export const crossStationLabelOf = (
  t: TFunction,
  isAddition: boolean | undefined,
  mainProductName: string | null | undefined,
  mainStationName: string | null | undefined,
): string | null => {
  if (!isAddition || !mainProductName) return null;
  return mainStationName
    ? t("monitors.additionToProductFromStation", {
        product: mainProductName,
        station: mainStationName,
      })
    : t("monitors.additionToProduct", { product: mainProductName });
};

// Малка ⤷ стрелка пред подтекста — ехо на TreeBranch клона от списъчния изглед.
export const CrossStationArrowIcon = () => (
  <svg
    width={11}
    height={11}
    viewBox="0 0 11 11"
    fill="none"
    aria-hidden
    className="shrink-0"
  >
    {/* var() не работи в SVG атрибут → цветът стои в style prop-а */}
    <path
      d="M1.5 0 V2.5 Q1.5 7.5 6.5 7.5 H8.5"
      style={{ stroke: "var(--color-muted)" }}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M6.5 5.2 L8.8 7.5 L6.5 9.8"
      style={{ stroke: "var(--color-muted)" }}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
